/*
Content enhancements that run on every page after the DOM is parsed (loaded with defer).

1. Wrap every content <table> in a horizontally scrollable container so wide
   Google-Docs tables never break the layout on small screens.
2. Feature-image fallback: on a post page that has NO real feature image, promote
   the first content image into a hero figure at the top of the article header and
   remove it from the body (de-dupe). 50 of 55 posts ship without a feature_image.

Idempotent and guarded against missing DOM nodes.
*/

function wrapTables(content) {
    content.querySelectorAll('table').forEach((table) => {
        if (table.closest('.gh-table-wrap')) return;
        const wrap = document.createElement('div');
        wrap.className = 'gh-table-wrap';
        wrap.setAttribute('role', 'region');
        wrap.setAttribute('aria-label', 'Таблица, прокручивается по горизонтали');
        wrap.tabIndex = 0;
        table.parentNode.insertBefore(wrap, table);
        wrap.appendChild(table);
    });
}

function promoteHero(content) {
    const header = document.querySelector('.gh-article .gh-header');
    if (!header) return;
    if (document.querySelector('.gh-feature-image')) return;
    if (header.querySelector('.mnr-promoted-hero')) return;

    const firstImg = content.querySelector('img');
    if (!firstImg) return;

    const sourceFigure = firstImg.closest('figure');

    const fig = document.createElement('figure');
    fig.className = 'mnr-promoted-hero gh-feature-image';

    const clone = firstImg.cloneNode(true);
    clone.removeAttribute('loading');
    clone.setAttribute('fetchpriority', 'high');
    fig.appendChild(clone);

    const caption = sourceFigure && sourceFigure.querySelector('figcaption');
    if (caption) fig.appendChild(caption.cloneNode(true));

    header.appendChild(fig);

    // De-dupe: drop the original image (or its whole figure if it only held this image)
    if (sourceFigure && sourceFigure.querySelectorAll('img').length === 1) {
        sourceFigure.remove();
    } else {
        firstImg.remove();
    }
}

export default function contentEnhance() {
    const content = document.querySelector('.gh-content');
    if (!content) return;
    wrapTables(content);
    promoteHero(content);
}
